import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddToQueue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon / add-to-queue",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "icon",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M20 2H8C6.897 2 6 2.897 6 4V16C6 17.103 6.897 18 8 18H20C21.103 18 22 17.103 22 16V4C22 2.897 21.103 2 20 2ZM8 16V4H20L20.002 16H8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M4 8H2V20C2 21.103 2.897 22 4 22H16V20H4V8ZM15 6H13V9H10V11H13V14H15V11H18V9H15V6Z",
				fill: "white"
			})]
		})
	})
});
export default SvgAddToQueue;
